"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationEvent = void 0;
const json_schema_library_1 = require("json-schema-library");
const react_1 = require("react");
const notification_context_1 = require("../../notification/notification-context");
const detail_context_1 = require("../../../composite/detail/detail-context");
const detail_types_1 = require("../../../composite/detail/detail-types");
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const notification_template_utils_1 = require("../notification-template-utils");
function callApi(url, itemId) {
    return (0, abortable_fetch_1.abortableFetch)(`${url}/${itemId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });
}
function useNotificationEvent(itemId) {
    const [keys, setKeys] = (0, react_1.useState)([]);
    const { notificationEventUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    const { source, mode } = (0, react_1.useContext)(detail_context_1.DetailContext);
    const fetch = (0, react_1.useRef)(null);
    const getNotificationEvent = (0, event_callback_hook_1.useEventCallback)(async () => {
        try {
            source.setLoading(true);
            if (fetch.current !== null) {
                fetch.current.abort();
            }
            fetch.current = callApi(notificationEventUrl, itemId);
            const response = await fetch.current.json();
            const core = new json_schema_library_1.Draft04(response.schema);
            const template = core.getTemplate({});
            const keys = Object.keys((0, notification_template_utils_1.flatten)(template)).map((key) => ({
                jsonSchemaKey: `#/${key.replace('.', '/')}`,
                freeMarkerKey: `$\{(${key})!}`,
                description: core.getSchema(`#/${key.replace('.', '/')}`, {})['description'],
            }));
            setKeys(keys);
        }
        catch (err) {
            console.log(err);
            return undefined;
        }
        finally {
            source.setLoading(false);
        }
    });
    (0, react_1.useEffect)(() => {
        if (itemId && [detail_types_1.DetailMode.NEW, detail_types_1.DetailMode.EDIT].includes(mode)) {
            getNotificationEvent();
        }
        else {
            setKeys([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemId, mode]);
    return {
        keys,
    };
}
exports.useNotificationEvent = useNotificationEvent;
//# sourceMappingURL=pick-event-hook.js.map